import restCrudReducer from '../../../np-crud/store/restCrudReducer';
import * as actionTypes from './actionTypes';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'ADMIN',
    entityName: 'INTEGRITY_CHECK',
});

const initialState = {
    ...crudInitialState,
    deletedIntegrityCheck: {},
    deleting: false,
    saving: false,
    status: false
};
const reducer = (state = initialState, action) => {
    // Handle CRUD actions
    const newState = crudReducer(state, action);
    // If CRUD reducer handled the action
    if (newState !== null) {
        return newState;
    }

    // Handle other actions
    switch (action.type) {
        case actionTypes.ADMIN_CHECK_SUCCESS:
            return state = { ...state, status: !state.status };
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        default:
            return state;
    }
};

export default reducer;
